import api from './axios';

export const getWorkTasks = (params) => api.get('/work-tasks', { params });
export const getWorkTask = (id) => api.get(`/work-tasks/${id}`);
export const getAssignableUsers = (params) => api.get('/work-tasks/assignable-users', { params });
export const createWorkTask = (data, files) => {
  if (files && files.length > 0) {
    const formData = new FormData();
    formData.append('description', data.description);
    formData.append('urgency', data.urgency);
    data.assigned_to_user_ids.forEach((id) => formData.append('assigned_to_user_ids[]', id));
    files.forEach((file) => formData.append('files[]', file));
    // axios instance'inin varsayilan 'Content-Type: application/json' header'i
    // FormData gonderirken de uygulaniyor ve axios FormData'yi JSON'a
    // cevirip gonderiyordu (dosya kismi bos {} olarak gidiyordu). Content-Type'i
    // undefined yaparak bu istege ozel varsayilani iptal ediyoruz - tarayici
    // dogru multipart + boundary header'ini kendisi ekliyor.
    return api.post('/work-tasks', formData, { headers: { 'Content-Type': undefined } });
  }
  return api.post('/work-tasks', data);
};
export const toggleWorkTaskComplete = (id, completion_note) => api.patch(`/work-tasks/${id}/toggle-complete`, { completion_note });
export const appendWorkTaskNote = (id, note) => api.patch(`/work-tasks/${id}/append-note`, { note });
export const handoffWorkTask = (id, to_user_id, note) => api.patch(`/work-tasks/${id}/handoff`, { to_user_id, note });
// Coklu atamada bir kisinin "tamamladim"ini atayan/yonetici geri alabilir.
// Sebep ZORUNLU (backend de sart kosuyor): kisiye bildirim gidiyor ve
// gecmise ara not olarak yaziliyor, "neden geri alindi" sorusu ortada kalmasin.
export const reopenWorkTaskAssignee = (id, user_id, reason) => api.patch(`/work-tasks/${id}/reopen-assignee`, { user_id, reason });
export const deleteWorkTask = (id) => api.delete(`/work-tasks/${id}`);

export const uploadWorkTaskAttachment = (id, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/work-tasks/${id}/attachments`, formData, {
    headers: { 'Content-Type': undefined },
    onUploadProgress,
  });
};
export const deleteWorkTaskAttachment = (id, attachmentId) => api.delete(`/work-tasks/${id}/attachments/${attachmentId}`);
